<template>
  <!-- begin:: Aside -->
  <div
    class="aside aside-left aside-fixed d-flex flex-column flex-row-auto"
    id="kt_aside"
    ref="kt_aside"
  >
    <!-- begin:: Aside -->
    <KTBrand></KTBrand>
    <!-- end:: Aside -->

    <Dialog
      :closeOnEscape="false"
      :visible.sync="showModalSql"
      :containerStyle="{ width: '50vw' }"
      :maximizable="true"
      :modal="true"
      :contentStyle="{
        margin: '0',
        padding: '0',
        height: '100vh',
        'overflow-x': 'hidden'
      }"
    >
      <template #header>
        <div class="holographic-container">
          <div class="holographic-card">
            <div class="d-flex align-items-center mb-0">
              <img
                class="turtle-cat-img"
                src="/turtlecat.png"
                alt=""
                style="height: 50px"
              />
              <h5 class="mb-0">Turtlecat</h5>
            </div>
          </div>
        </div>
      </template>
      <SQLRunner v-if="showModalSql"></SQLRunner>
    </Dialog>

    <div
      class="aside-menu-wrapper flex-column-fluid"
      id="kt_aside_menu_wrapper"
    >
      <div
        ref="kt_aside_menu"
        id="kt_aside_menu"
        class="aside-menu"
        data-menu-scroll="1"
        data-menu-vertical="1"
        data-menu-dropdown-timeout="500"
        v-bind:class="asideMenuClass"
      >
        <div id="AsideToggleWrapper">
          <button
            class="brand-toggle btn btn-sm px-0 d-flex align-items-center justify-content-center w-100 my-2"
            id="kt_aside_toggle"
            ref="kt_aside_toggle"
          >
            <span
              class="svg-icon svg-icon-warning svg-icon-xl"
              style="margin: 0 !important"
            >
              <div class="d-flex align-items-center justify-content-center">
                <i
                  id="AssideToggleIcon"
                  class="fa fa-chevron-right"
                  aria-hidden="true"
                ></i>
              </div>
            </span>
          </button>
          <div
            class="input-group mb-3"
            id="AsideSearcher"
            style="margin-top: -20px !important"
          >
            <div class="input-group-prepend">
              <span class="input-group-text m-0" id="basic-addon1">
                <i class="fa fa-search" style="font-size: 0.95em"></i>
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="Buscar"
              v-model="search_menus"
            />
          </div>
        </div>
        <KTMenu :search_menus="search_menus"></KTMenu>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#AsideSearcher {
  margin: auto !important;
  width: 94%;
  border: 1px solid #f1f1f1;
  border-radius: 10px !important;
  .input-group-text {
    background: transparent !important;
    border: none !important;
    border-radius: 8px 0 0 8px;
  }
  input {
    border-radius: 0 8px 8px 0;
    margin-left: 0 !important;
    padding-left: 0 !important;
    color: #000;
    border: none !important;
  }
}

#AssideToggleIcon {
  padding: 0 !important;
  margin: 0 !important;
  display: block;
  &:hover {
    color: #ffa800 !important;
  }
}

.aside-minimize {
  #AsideSearcher {
    input::placeholder {
      color: transparent;
    }

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .input-group-prepend {
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 99;
    }
    input {
      pointer-events: none;
    }
  }
}

.aside-minimize #AssideToggleIcon {
  display: block !important;
}

#AssideToggleIcon {
  display: none !important;
}

.aside-minimize #AsideSearcher {
  display: none !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import KTBrand from "@/view/layout/brand/Brand.vue";

import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTMenu from "@/view/layout/aside/Menu.vue";
import KTLayoutAsideToggle from "@/assets/js/layout/base/aside-toggle.js";
import SQLRunner from "@/view/pages/painel/automacao/campanha/components/SQLRunner.vue";
import Dialog from "primevue/dialog";

export default {
  name: "KTAside",
  data() {
    return {
      insideTm: 0,
      outsideTm: 0,
      search_menus: "",
      ctrlXPressedAt: 0,
      showModalSql: false
    };
  },
  components: {
    KTBrand,
    KTMenu,
    SQLRunner,
    Dialog
  },
  mounted() {
    this.$nextTick(() => {
      const asideRef = this.$refs["kt_aside"];
      KTLayoutAsideToggle.init(this.$refs["kt_aside_toggle"]);

      // Init Aside
      KTLayoutAside.init(asideRef);

      asideRef.querySelectorAll("a[class='menu-link']").forEach((item) => {
        item.addEventListener("click", () => {
          KTLayoutAside.getOffcanvas().hide();
        });
      });

      // Init Aside Menu
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);
    });

    if (this.currentUserPersonalInfo.mostrarSqlRunner) {
      console.warn("SQL Runner is enabled");
      window.addEventListener("keydown", this.handleDoubleCtrlX);
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleDoubleCtrlX);
  },
  methods: {
    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseEnter() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        // check if the left aside menu is fixed
        if (document.body.classList.contains("aside-fixed")) {
          if (this.outsideTm) {
            clearTimeout(this.outsideTm);
            this.outsideTm = null;
          }

          // if the left aside menu is minimized
          if (document.body.classList.contains("aside-minimize")) {
            document.body.classList.add("aside-minimize-hover");

            // show the left aside menu
            document.body.classList.remove("aside-minimize");
          }
        }
      }
    },

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseLeave() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        if (document.body.classList.contains("aside-fixed")) {
          if (this.insideTm) {
            clearTimeout(this.insideTm);
            this.insideTm = null;
          }

          if (document.querySelector(".aside-menu .scroll")) {
            document.querySelector(".aside-menu .scroll").scrollTop = 0;
          }

          // if the left aside menu is expand
          if (document.body.classList.contains("aside-minimize-hover")) {
            // hide back the left aside menu
            document.body.classList.remove("aside-minimize-hover");
            document.body.classList.add("aside-minimize");
          }
        }
      }
    },
    handleDoubleCtrlX(e) {
      if (e.ctrlKey && e.key.toLowerCase() === "x") {
        const now = Date.now();
        if (now - this.ctrlXPressedAt < 400) {
          this.openModal();
          this.ctrlXPressedAt = 0; // reset
        } else {
          this.ctrlXPressedAt = now;
        }
      }
    },
    openModal() {
      this.showModalSql = true;
    },
    closeModal() {
      this.showModalSql = false;
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses", "currentUserPersonalInfo"]),

    /**
     * Get extra classes for menu based on the options
     */
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  }
};
</script>
<style lang="scss">
#AsideToggleWrapper {
  position: sticky;
  top: 0;
  z-index: 95;
  background: #fff;
}
</style>
